import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function NikoFacilityOrderNewFlowMissingInventoryCountConfirmModalTemplate({ nikoFacilityOrderNewFlowMissingInventoryCountConfirmModalStore, t }) {
    const {
        processInventory,
        isLoading,
        modalParams
    } = nikoFacilityOrderNewFlowMissingInventoryCountConfirmModalStore;

    return (
        <section>
            <div className="modal__body type--center">
                <i className="status--sqare is-big over-circle u-mar--bottom--med u-radius--full" />
                <h3 className='modal__header__title u-mar--bottom--med'>Missing Inventory Count</h3>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    disabled={isLoading}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label="Confirm"
                    disabled={isLoading}
                    onClick={() => processInventory()}
                    rotate icon={
                        isLoading
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

NikoFacilityOrderNewFlowMissingInventoryCountConfirmModalTemplate.propTypes = {
    nikoFacilityOrderNewFlowMissingInventoryCountConfirmModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoFacilityOrderNewFlowMissingInventoryCountConfirmModalTemplate);
